import { VitalityDrugDescription } from "generated/api"
import { api } from "careand-redux/api/ApiThunks"
import { createResettableSlice } from "careand-redux/utils/makeResettable"
import { unwrap } from 'careand-redux/utils/unwrap'

export type AdministeredDrugDescriptionsState = VitalityDrugDescription[]

const initialState: AdministeredDrugDescriptionsState = []

const slice = createResettableSlice({
  name: 'administeredDrugDescriptions',
  initialState,
  reducers: {},
  extraReducers: builder => builder
    .addCase(api.HealthRecords.getVitalityDrugDescriptions.fulfilled, unwrap((state, descriptions) => descriptions))
})

export default slice.reducer
